export default __webpack_public_path__ + "static/media/spa.90d0f645.png";